import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Resolves the Tripo3D material setting from the run's materialMode attribute.
 * Anything other than 'shaded' or 'PBR' falls back to GEOMETRY_ONLY.
 *
 * @param {string} [materialMode] - Tripo3D materialMode value ('shaded' | 'PBR' | other)
 * @returns {string} - One of MATERIAL.BASIC | MATERIAL.PBR | MATERIAL.GEOMETRY_ONLY
 */
export const deriveMaterialForTripo3D = (materialMode) => {
  if (materialMode === 'shaded') {
    return MATERIAL.BASIC
  }

  if (materialMode === 'PBR') {
    return MATERIAL.PBR
  }

  return MATERIAL.GEOMETRY_ONLY
}
